import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ChatInputService } from '@app/services/chat-input.service';
import { TabService } from '@app/services/tab.service';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-empty-chat',
  imports: [CommonModule, TranslocoPipe],
  standalone: true,
  templateUrl: './empty-chat.component.html',
  styles: [
    `
      :host {
        @apply flex flex-col items-stretch justify-center bg-white px-4 py-4 lg:px-6 3xl:px-0;
        @apply cursor-pointer;
      }
    `,
  ],
})
export class EmptyChatComponent {
  chatInputService = inject(ChatInputService);
  translocoService = inject(TranslocoService);
  tabService = inject(TabService)

  addSuggestion(num: number) {
    const translatedText = this.translocoService.translate(`chat.suggestion.${num}.text`);
    this.chatInputService.setChatInput(this.tabService.activeTab()?._id,translatedText + ' ');
  }
}
